import { useContext } from 'react'

import { CalendarContext } from '../../Calendar.contexts'

export function useCalendarContext() {
  return useContext(CalendarContext)
}
